import React, { useEffect } from "react";

export type UseMountedProps = {
  anchor: string;
  timeout?: number;
}

export const useMounted = (props: UseMountedProps): {
  mounted: boolean
} => {
  const [mounted, setMounted] = React.useState(false);
  const anchor = props.anchor;
  
  useEffect(() => {
    setMounted(false);
    const idTO = setTimeout(() => setMounted(true), props?.timeout || 10);
    return () => clearTimeout(idTO);
  }, [anchor]);

  return {
    mounted
  }
}